import { NodeType } from '@starsoft/common/hooks/transactions/useNodesFromTransactions/props';
import { Nullable } from '@starsoft/common/interfaces';
import { TransactionTransfer } from '@starsoft/common/models/transaction/transfer';

function formatAddress(address?: string) {
  if (!address) {
    return '-';
  }

  return `${address.substring(0, 6)}...${address.substring(
    address.length - 4,
  )}`;
}

export function nodeLabelHandler(
  transfer: TransactionTransfer,
  type: NodeType,
): Nullable<string> {
  switch (type) {
    case NodeType.Sender:
      return formatAddress(transfer?.sender);
    case NodeType.Coin:
      return null;
    case NodeType.Receiver:
      return formatAddress(transfer?.receiver);
    default:
      return type;
  }
}
